//import { browserHistory } from 'react-router'

export function get(url) {
  //var parsified = url.split("/", 4);
 // var lang = parsified[parsified.length-1];

  // Return a new promise.
  return new Promise(function(resolve, reject) {
    // Do the usual XHR stuff
    const req = new XMLHttpRequest();
    req.open('GET', url);
    req.setRequestHeader('Accept', 'application/json' );
    req.onload = function() {
      // This is called even on 404 etc
      // so check the status
      if (req.status === 200) {
        // Resolve the promise with the response text
        resolve(req.response);
      }
      else {
        // Otherwise reject with the status text
        // which will hopefully be a meaningful error
       // reject(Error(req.statusText));
        resolve('{"status": "error"}');
      }
    };

    // Handle network errors
    req.onerror = function() {
      reject(Error("Network Error"));
    };

    // Make the request
    req.send();
  });
}

export function post(url, body) {
  // Return a new promise.
  return new Promise(function(resolve, reject) {
    // Do the usual XHR stuff
    const req = new XMLHttpRequest();
    req.open('POST', url);
    req.setRequestHeader('Content-Type', 'application/json' );
    req.onload = function() {
      // This is called even on 404 etc
      // so check the status
      if (req.status === 200 || req.status === 201) {
        // Resolve the promise with the response text
        resolve(req.response);
      }
      else {
        // Otherwise reject with the status text
        // which will hopefully be a meaningful error
        reject(Error(req.statusText));
      }
    };

    // Handle network errors
    req.onerror = function() {
      reject(Error("Network Error"));
    };

    // Make the request
    req.send(JSON.stringify(body));
  });
}

export function ajaxGet(url, self, callback=null) {
  get(url).then(function(response){
    return JSON.parse(response);
  }).then(function(response) {
    self.setState({data: response}, callback);
  });
}

export function ajaxPost(url, body, self) {
  post(url, body).then(
    function(
      response
  ){
    return JSON.parse(response);
  }).then(function(response) {
    self.setState({data: response});
  });

}

export function ajaxGetHTML(url, self) {
  get(url).then(
    function(
      response
    ){
      return response;
    }).then(function(response) {
    self.setState({data: response});
  });
}




/** WEBPACK FOOTER **
 ** ./src/helpers/apiData.js
 **/